import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { useHistory, useRouteMatch } from "react-router-dom";
import TaskSendEmailType from "../../../enum/TaskSendEmailType";
import FinalCustomer from "../../../model/FinalCustomer";
import { useAuthentication } from "../../../reducer/authentication";
import { useLoading } from "../../../reducer/loading";
import { ServiceApi } from "../../../service/ServiceApiWithLoading";
import TaskApi from "../../../service/TaskApi";
import { delay } from "../../../utils";
import RouteIdParams from "../../System/RouteIdParams";
import TicketsForm, { TicketsFormData } from "./TicketsForm";
import ConfigTicketRegistCustomerApi from "../../../service/ConfigTicketRegistCustomerApi";

const api = new TaskApi();
const configTicketRegistCustomerApi = new ConfigTicketRegistCustomerApi();
const finalCustomerApi = new ServiceApi<FinalCustomer>('finalCustomer');

interface TicketsAddProps {
    
}

export default function TicketsAdd(props: TicketsAddProps) {
    const { user } = useAuthentication();
    const match = useRouteMatch<RouteIdParams>();
    const setLoading = useLoading();

    const [finalCustomerId, setFinalCustomerId] = useState<number | null | undefined>(null);
    const [commboxId, setCommboxId] = useState<number | null>(null);

    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        finalCustomerApi.getList({ where: [['name', '=', 'Commbox']] }).then((finalCustomerList) => {
            if (finalCustomerList.length > 0) {
                setCommboxId(finalCustomerList[0].id);
            }
        });
    }, []);

    async function onSubmit(values: TicketsFormData, isDirty?: boolean, submitType?: string | null) {
        const configTicketRegistCustomer = await  configTicketRegistCustomerApi.getConfigTicketRegistCustomer();
        if (isDirty === false || !configTicketRegistCustomer) {
            onCancel();
            return;
        }
        setLoading(true);
        try {
            const result = await api.insert({
                name: values.name,
                description: values.description,
                ticket_status_id: configTicketRegistCustomer.ticket_status_id, //criar config
                final_customer_id: values.final_customer_id,
                ticket_type_id: configTicketRegistCustomer.ticket_type_id, //criar config
                user_id: configTicketRegistCustomer.user_id, //criar config
                ticket_origin_id: configTicketRegistCustomer.ticket_origin_id, //criar config
                created_by_user_id: user?.id || null,
                register_origin: 'taskSupport'
            });
            if (!result) throw new Error('Erro ao salvar chamado');
            await api.updateCustomerContacts(result.id, values.customer_contacts);            
            const relationCommentIdxId: { idx: number, id: number }[] = [];
            if (values.comments && values.comments.length > 0) {
                await Promise.all(values.comments.map(async (comment, index) => {
                    if (comment.id === 0 && comment.comment) {
                        let savedComment = await api.saveComment(result.id, comment.comment, comment.is_public, comment.user_id, comment.type, comment.time_counter?.hours, comment.time_counter?.minutes, comment.comment_task_users?.map((ctu) => ctu.user_id));
                        relationCommentIdxId.push({ idx: index, id: savedComment.id });
                    }
                    return;
                }))
            }
            if (values.attachments && values.attachments.length > 0) {
                for (const attachment of values.attachments) {
                    if (attachment.file || attachment.system_attachment_id) {
                        let commentRelItem = relationCommentIdxId.find(o => o.idx === attachment.commentIdx)
                        await api.saveAttachment(attachment.file || null, result.id, attachment.description, attachment.type, commentRelItem?.id, attachment.system_attachment_id);
                    }
                }
            }            
            await api.sendEmail(result.id, TaskSendEmailType.StatusChange, user?.id);
            await api.sendEmail(result.id, TaskSendEmailType.RegisterAssignedTo);

            if(relationCommentIdxId.length > 0) {
                await api.sendCommentsEmail(relationCommentIdxId.map(o => o.id));
            }
            enqueueSnackbar('Chamado salvo com sucesso!', { variant: 'success' });
            await delay(100);
            if (submitType === 'save') {
                var matchUrl = match?.url.replace(/\/add/g, `/${result.id}`);
                history.replace(matchUrl);
            } else {
                onCancel();
            }
        } catch (e) {
            if (e instanceof Error) {
                enqueueSnackbar(e.message, { variant: 'error' });
            }
        } finally {
            setLoading(false);
        }
    }

    function onCancel() {
        if (history.length > 2) {
            history.goBack();
        } else {
            history.push(`/support/tickets/open`);
        }
    }

    const title: React.ReactNode = 'Cadastro de Chamado';

    return (
        <>
            <BreadcrumbsItem to={match.url}>
                {title}
            </BreadcrumbsItem>
            <TicketsForm
                title={title}
                onCancel={onCancel}
                onSubmit={onSubmit}
                key={`addForm`}
            />
        </>
    );
}